// extracted by mini-css-extract-plugin
export default {"container":"s2-z"};